import styled from 'styled-components';

export const ContentText = styled.p`
  font-size: 16px;
  color: ${props => props.theme.interface5};
  margin-bottom: 19px;
`;
